import React, { Component } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { Layout } from "antd";
import AuthRoute from "../AuthRoute";
import NonAuthRoute from "../NonAuthRoute";
import Edit from "../Edit";
import Admin from "../Admin";
import LogIn from "../LogIn";
import Landing from "../Landing";
import FAQ from "../FAQ";
import Survey from "../Survey";
import PasswordReset from "../PasswordReset";

const { Content } = Layout;

class C extends Component {
	render() {
		const { location } = this.props;
		if (!location) return null;
		return (
			<Content>
				<Switch location={location}>
					<Route exact path="/" component={Landing}/>
					<Route path="/faq" component={FAQ}/>
					<Route path="/survey" component={Survey}/>
					<NonAuthRoute path="/login" component={LogIn}/>
					<AuthRoute path="/admin" component={Admin}/>
					<AuthRoute path="/edit" component={Edit}/>
					<Route path="/password_reset" component={PasswordReset}/>
					<Route path="/password_reset" component={PasswordReset}/>
					<Route path="*" component={() => <span>404</span>}/>
				</Switch>
			</Content>
		);
	}
}

export default withRouter(C);



// WEBPACK FOOTER //
// ./src/components/Content/Content.js